import React, { Component, createElement } from 'react';

import { twclsx } from 'utils/twclsx';

class Form extends Component<React.FormHTMLAttributes<HTMLFormElement>> {
    handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    };

    render() {
        // eslint-disable-next-line react/prop-types
        const { className: c, ...props } = this.props;
        const className = twclsx(
            'inline-flex',
            'items-center',
            'justify-center',
            'py-2.5',
            'px-3.5',
            'rounded-lg',
            'font-medium',
            'transition-all'
        );

        const onSubmit = props.onSubmit ? props.onSubmit : this.handleSubmit;

        return createElement('form', { ...props, className: c ? c : className, onSubmit: onSubmit });
    }
}

export default Form;
